<div class="px-4 py-2 border-b flex justify-between content-between items-center" matDialogTitle>
    <button class="bg-gray-200" mat-dialog-close mat-icon-button>
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="p-4 flex flex-col gap-4 overflow-y-auto" style="max-height: 80vh" matDialogContent>
    <p class="text-xl font-bold me-auto">{{ "campaign.thanks_contacting" | transloco }}</p>
    <div class="flex flex-col gap-4">
        <div class="grid grid-cols-1 gap-4">
            <span>{{ "campaign.contact_soon" | transloco }}</span>
        </div>
    </div>
    <div class="px-4 py-2 border-t flex justify-end items-center" matDialogActions>
        <button (click)="close()" color="primary" mat-raised-button>
            {{ "campaign.close" | transloco }}
        </button>
    </div>
</div>
